import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {featureKeyApp} from './feature-app.selectors';
import {FeatureAppReducer} from './feature-app.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(featureKeyApp, FeatureAppReducer),
  ],
})
export class FeatureAppModule {
}
